<h1 mat-dialog-title style="margin-bottom: 0px">Jou bespreking</h1>
<p>{{ data.serviceTime | date: "medium" }}</p>
<p
  *ngIf="
    data.venueCapacity -
      dataService.allBookingsDictionary[data.serviceId][data.venueId] >
    1
  "
>
  {{
    data.venueCapacity -
      dataService.allBookingsDictionary[data.serviceId][data.venueId]
  }}
  plekke beskikbaar
</p>
<p
  *ngIf="
    data.venueCapacity -
      dataService.allBookingsDictionary[data.serviceId][data.venueId] ===
    1
  "
>
  {{
    data.venueCapacity -
      dataService.allBookingsDictionary[data.serviceId][data.venueId]
  }}
  plek beskikbaar
</p>
<p
  *ngIf="
    data.venueCapacity -
      dataService.allBookingsDictionary[data.serviceId][data.venueId] <=
    0
  "
>
  Geen plek beskikbaar
</p>
<div mat-dialog-content *ngIf="addPeople">
  <div class="wrapper">
    <h3 mat-dialog-title>
      Voeg besonderhede in en druk "Stoor" om jou lys uit te brei
    </h3>
    <mat-form-field class="full-width">
      <mat-label>Naam</mat-label>
      <input matInput [(ngModel)]="name" />
    </mat-form-field>
    <mat-form-field class="full-width">
      <mat-label>Van</mat-label>
      <input matInput required [(ngModel)]="surname" />
    </mat-form-field>
    <mat-form-field class="full-width">
      <mat-label>Epos</mat-label>
      <input matInput type="email" [(ngModel)]="email" />
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions align="end" *ngIf="addPeople">
  <button mat-raised-button (click)="add()" style="width: 150px">Stoor</button>
</div>
<div mat-dialog-content *ngIf="people.length > 0">
  <div class="wrapper">
    <h3 mat-dialog-title>Vir wie wil jy bespreek?</h3>
    <p *ngIf="people.length === 0">
      Jy het nog geen individue nie. Voeg besonderhede bo en druk "Stoor" om jou
      lys uit te brei.
    </p>
    <mat-selection-list [(ngModel)]="selectedPeople">
      <mat-list-option
        *ngFor="let person of people"
        [selected]="person.attending"
        [value]="person"
      >
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div style="display: flex; align-items: center">
            <div style="display: flex; flex-direction: column">
              <div>
                <h3 matLine>{{ person.name }}</h3>
              </div>
            </div>
          </div>
          <!-- <div>
            <button mat-icon-button (click)="edit(person)">
              <mat-icon>edit</mat-icon>
            </button>
          </div> -->
        </div>
      </mat-list-option>
    </mat-selection-list>
  </div>
</div>
<p
  *ngIf="
    data.venueCapacity -
      dataService.allBookingsDictionary[data.serviceId][data.venueId] <=
    0
  "
>
  Jammer, daar is geen plek beskikbaar nie
</p>
<div mat-dialog-actions>
  <button mat-raised-button *ngIf="!addPeople" (click)="addPeople = true">
    <mat-icon>person_add</mat-icon>
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="bespreek()"
    *ngIf="
      people.length > 0 &&
      selectedPeople.length > 0 &&
      bookingList.length === 0 &&
      data.venueCapacity -
        dataService.allBookingsDictionary[data.serviceId][data.venueId] >=
        selectedPeople.length - bookingList.length
    "
  >
    Bespreek vir {{ selectedPeople.length }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="bespreek()"
    *ngIf="
      people.length > 0 &&
      selectedPeople.length > bookingList.length &&
      bookingList.length > 0 &&
      data.venueCapacity -
        dataService.allBookingsDictionary[data.serviceId][data.venueId] >=
        selectedPeople.length - bookingList.length
    "
  >
    + {{ selectedPeople.length - bookingList.length }}
    <mat-icon>person</mat-icon>
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="bespreek()"
    *ngIf="
      people.length > 0 &&
      selectedPeople.length < bookingList.length &&
      bookingList.length > 0
    "
  >
    - {{ bookingList.length - selectedPeople.length }}
    <mat-icon>person</mat-icon>
  </button>
  <button
    mat-raised-button
    color="warn"
    (click)="bespreek()"
    *ngIf="people.length === 0 && bookingList.length > 0"
  >
    Verwyder
  </button>
</div>
